<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <c-datepicker
            :range="true"
            defaultStart="-1y"
            defaultEnd="0y"
            :isToyear="true"
            label="기간(이수일 기준)"
            name="period"
            v-model="searchParam.period"
          />
        </div>
        <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <c-plant 
            type="search" 
            name="plantCd" 
            v-model="searchParam.plantCd" 
            @input="getCourse"/>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <c-dept 
            :isFirstValue="false" 
            type="search" 
            name="deptCd" 
            v-model="searchParam.deptCd"/>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <c-select
            :comboItems="courseItems"
            type="search"
            itemText="educationCourseName"
            itemValue="eduCourseId"
            name="eduCourseId"
            label="교육과정"
            v-model="searchParam.eduCourseId"
          >
          </c-select>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <c-select
            type="none"
            :comboItems="kindItems"
            itemText="codeName"
            itemValue="code"
            name="educationKindCdLarge"
            label="교육종류1"
            v-model="searchParam.educationKindCdLarge"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="교육대상자 도래일 목록"
      tableId="table"
      :columns="grid.columns"
      :data="grid.data"
      :merge="grid.merge"
      :checkClickFlag="false"
      rowKey="eduEducationId"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <div>
          <q-btn-group outline>
            <c-btn 
              v-if="editable && grid.data.length > 0" 
              icon="save" 
              label="비고저장" 
              @btnClicked="saveRemark" />
            <c-btn label="검색" icon="search" @btnClicked="getList" />
          </q-btn-group>
        </div>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name==='nextEducationDate'">
          <span>
            {{props.row.nextEducationDate}}
            <q-badge v-if="props.row.arrivalFlag === 'Y'" color="negative" :label="props.row.diffDay+'일전'" class="blinking" />
          </span>
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: "education-arrival-date",
  props: {
    eduInfo: {
      type: Object,
      default(){
        return {
          educationKindCdLarge: '',
        }
      },
    },
  },
  data() {
    return {
      grid: {
        merge: [
          { index: 0, colName: 'userId' },
          { index: 1, colName: 'userId' },
          { index: 2, colName: 'userId' },
          { index: 3, colName: 'userId' },
          { index: 4, colName: 'userId' },
        ],
        columns: [
          {
            name: "rownum",
            field: "rownum",
            label: "#",
            style: 'width:40px',
            align: "center",
            sortable: true,
          },
          {
            name: "plantName",
            field: "plantName",
            label: "사업장",
            style: 'width:80px',
            align: "center",
            sortable: true,
          },
          {
            name: "deptName",
            field: "deptName",
            label: "부서",
            align: "center",
            style: 'width:170px',
            sortable: true,
          },
          {
            name: "userName",
            field: "userName",
            label: "대상자",
            align: "center",
            style: 'width:120px',
            sortable: true,
          },
          {
            name: "jobName",
            field: "jobName",
            label: "직책",
            align: "center",
            style: 'width:80px',
            sortable: true,
          },
          {
            name: "spotName",
            field: "spotName",
            label: "직위",
            align: "center",
            style: 'width:80px',
            sortable: true,
          },
          {
            name: "educationCourseName",
            field: "educationCourseName",
            label: "교육과정",
            style: 'width:350px',
            align: "left",
            sortable: true,
          },
          {
            name: "educationKindName",
            field: "educationKindName",
            label: "교육종류1",
            style: 'width:100px',
            align: "center",
            sortable: true,
          },
          {
            name: "totalAttendanceTime",
            field: "totalAttendanceTime",
            label: "총 교육시간(h)",
            style: 'width:100px',
            align: "right",
            type: 'cost',
            sortable: true,
          },
          {
            name: "recentEducationDate",
            field: "recentEducationDate",
            label: "최근 교육일",
            style: 'width:100px',
            align: "center",
            sortable: true,
          },
          {
            name: "educationCycleName",
            field: "educationCycleName",
            label: "교육주기",
            style: 'width:80px',
            align: "center",
            sortable: true,
          },
          {
            name: "nextEducationDate",
            field: "nextEducationDate",
            label: "다음교육예정일",
            style: 'width:150px',
            type: 'custom',
            align: "center",
            sortable: true,
          },
          {
            name: "remark",
            field: "remark",
            label: "비고",
            style: 'width:120px',
            type: 'text',
            align: "left",
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        deptCd: '',
        eduCourseId: null,
        educationKindCdLarge: null,
        period: [],
        retireFlag: 'N'
      },
      kindItems: [],
      courseItems: [],
      editable: true,
      listUrl: '',
      courseUrl: '',
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  computed: {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.courseUrl = selectConfig.sop.edu.course.list.url;
      this.listUrl = selectConfig.sop.edu.arrivaldate.list.url;
      // code setting
      this.$comm.getComboItems('EDU_KIND_FST_CD').then(_result => {
        let attrVal1 = this.eduInfo.educationKindCdLarge == 'EKFC000001' ? 'SAF' : 'ENV'
        _result = this.$_.filter(_result, { attrVal1 : attrVal1 });
        _result.splice(0, 0, {
          codeName: '전체',
          code: attrVal1,
        })
        this.$set(this.$data, 'kindItems', _result)
      });
      this.$set(this.searchParam, 'educationKindCdLarge', this.eduInfo.educationKindCdLarge);
      // list setting
      this.getCourse();
      this.getList();
    },
    getCourse() {
      this.searchParam.eduCourseId = null;
      if (this.searchParam.plantCd) {
        this.$http.url = this.courseUrl;
        this.$http.type = 'GET';
        this.$http.param = {plantCd: this.searchParam.plantCd, useFlag: 'Y'};
        this.$http.request((_result) => {
          this.courseItems = _result.data;
        },);
      } else {
        this.courseItems = [];
      }
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    saveRemark() {
      let saveData = this.grid.data.filter( x => {
        return x.editFlag == 'U' || (x.editFlag == 'C' && x.remark)
      });
      if(saveData.length > 0) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '저장하시겠습니까?',
          type: 'info',
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.listUrl;
            this.$http.type = 'POST';
            this.$http.param = saveData;
            this.$http.request(() => {
              this.getList();
              window.getApp.$emit('ALERT', {
                title: '안내 ', /* 안내 */
                message: '저장되었습니다.', /* 저장되었습니다. */
                type: 'success', // success / info / warning / error
              });
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      } else {
        window.getApp.$emit('ALERT', {
          title: '안내 ', /* 안내 */
          message: '변경된 데이터가 없습니다.', /* 변경된 데이터가 없습니다. */
          type: 'info', // success / info / warning / error
        });
      }
    }
  },
};
</script>
